// import { Form } from 'antd';
import React, { ReactElement } from 'react';
import Filters from '../Filters';
import Dashboard from '../Dashboard';
import ReconciliationTable from '../ReconciliationTable';
import PageHeader from '../../../../../shared/components/pageHeader/PageHeader';
import ReconcilationHeader from '../ReconcilationHeader';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { ReconciliationState } from '../../../../../store/models/reconciliationModel';

const List = (): ReactElement => {
  const { viewId } = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  return (
    <div>
      <PageHeader
      rightComponent = {(): ReactElement => (
      process.env.REACT_APP_IS_RECONCILIATION_NEW_ENABLED === 'true' ?
      <ReconcilationHeader/> : <></>
    )}/>
      <Filters/>
      {
        viewId === 1 &&
        <Dashboard/>
      }
      <ReconciliationTable/>
    </div>
  );
};
export default List;
